import { render, staticRenderFns } from "./ConfigTemplateCard.vue?vue&type=template&id=db7c33bc"
import script from "./ConfigTemplateCard.vue?vue&type=script&lang=ts"
export * from "./ConfigTemplateCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.28.5__cache-loader@4.1.0_web_440794991c458c99f4ea4042de23b4db/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ZButton: require('/app/components/zeal/ZButton/ZButton.vue').default,BaseCard: require('/app/components/History/BaseCard.vue').default})
